import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Logo = () => (
  <span className="text-lg font-extrabold tracking-tight">
    <span style={{ color: "#ffffff" }}>Casino</span>
    <span style={{ color: "var(--cp-green)" }}>Picks</span>
  </span>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTopPicks = (e) => {
    e.preventDefault();
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("top-picks")?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById("top-picks")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const links = [
    { label: "Top Picks", onClick: goTopPicks, to: "/#top-picks" },
    { label: "About", to: "/about" },
    { label: "Contact", to: "/contact" },
  ];

  return (
    <header
      className="sticky top-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? "rgba(10,11,13,0.85)" : "rgba(10,11,13,0.6)",
        backdropFilter: "blur(10px)",
        borderBottom: `1px solid ${scrolled ? "var(--cp-border)" : "transparent"}`,
      }}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
        <Link to="/" onClick={() => setOpen(false)}>
          <Logo />
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {links.map((l) =>
            l.onClick ? (
              <a
                key={l.label}
                href={l.to}
                onClick={l.onClick}
                className="text-sm font-medium transition-colors hover:text-white"
                style={{ color: "var(--cp-text)" }}
              >
                {l.label}
              </a>
            ) : (
              <Link
                key={l.label}
                to={l.to}
                className="text-sm font-medium transition-colors hover:text-white"
                style={{ color: "var(--cp-text)" }}
              >
                {l.label}
              </Link>
            )
          )}
        </nav>

        <button
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          style={{ color: "var(--cp-text)" }}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="md:hidden"
          style={{ borderTop: "1px solid var(--cp-border)", background: "rgba(10,11,13,0.97)" }}
        >
          <nav className="mx-auto flex max-w-6xl flex-col gap-1 px-5 py-3">
            {links.map((l) =>
              l.onClick ? (
                <a
                  key={l.label}
                  href={l.to}
                  onClick={l.onClick}
                  className="py-2 text-sm font-medium transition-colors hover:text-white"
                  style={{ color: "var(--cp-text)" }}
                >
                  {l.label}
                </a>
              ) : (
                <Link
                  key={l.label}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="py-2 text-sm font-medium transition-colors hover:text-white"
                  style={{ color: "var(--cp-text)" }}
                >
                  {l.label}
                </Link>
              )
            )}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
